/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import PanCard from "./PanCard.container";

export default PanCard;
